import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/HomePurchaseOrders'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class HomePurchaseOrdersStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "HomePurchaseOrdersStore",
			variables: false,
		})
	}
}

export async function load_HomePurchaseOrders(params) {
  await initClient()

	const store = new HomePurchaseOrdersStore()

	await store.fetch(params)

	return {
		HomePurchaseOrders: store,
	}
}
